import React from "react";

import { connect } from 'react-redux';
import { fetchRMAItemDetails } from '../../redux/actions/orderAction'

class RMAPopUp extends React.Component {    

    render() {
        
        return ( 
            <div className="modal fade" id="rmaPopUpModal">
            <div className="modal-dialog modal-lg">
               <div className="modal-content"> 
                  <div className="modal-header">
                   <button type="button" className="close" data-dismiss="modal">&times;</button>
                  </div> 
                  <div className="modal-body">
                  {this.props.rmaData &&
                    <React.Fragment>                   
                     <div className="rma-title">
                  RETURN #{this.props.rmaData.orderMap.returnIdentifier} for ORDER #{this.props.rmaData.orderMap.orderId}
                  <div>
                     <small>{this.props.rmaData.orderMap.orderPlacedDateAndTime}</small>
                  </div>
               </div>             
                                 
               {this.props.rmaData.orderMap.shippingLabelUrl &&
               <div className="float-lefts mt-2">                 
                     <a target="_blank" href={this.props.rmaData.orderMap.shippingLabelUrl} className="backlink returnId-link">DOWNLOAD SHIPPING LABEL</a> 
                </div>
                  }
               </React.Fragment>
               }
               <hr></hr>
               <div className="p-sub-title">RETURNED ITEMS</div>
               {this.props.rmaData &&
                     <table className="table table-borderless td-pad-5">
                        <tbody>
                        {this.props.rmaData.returnItems.map((items, index) => (
                           <tr  className="border" key={index}>
                              <td className="w-40">
                                {items.imageUrl &&
                                     <div>
                                        <span className="item-img">
                                           <img alt="product"  src={items.imageUrl} className="popup-product-img"/>
                                          </span>
                                     </div>
                                 }
                              </td>
                              <td>
                              <ul className="reason-notest">
                              <li className="p-name">{items.itemName}</li>
                              {items.color &&
                                 <li className="p-name">Color : {items.color}</li>
                              } 
                              {items.size &&
                                 <li className="p-name">Size : {items.size}</li>
                              } 
                              {items.sku &&
                                    <li className="p-name">SKU: {items.sku}</li>
                              }  
                              <li className="reason">Reason: {items.returnReason}</li>
                              {items.returnNotes &&
                              <li className="reason">Notes: {items.returnNotes} </li>
                              }
                              </ul>                            
                   
                            </td>
                            <td className="float-right">qty:{items.returnQuantity}</td>
                            </tr>  
                        ))}                
                  </tbody>
                  </table>
               }
                  {this.props.rmaData &&
                  <div className="float-right">
                     <table className="table table-borderless td-pad-5" width="300px">
                        <tbody>
                           <tr>
                              <td align="right">Refund Subtotal</td>
                              <td className="float-right">${this.props.rmaData.orderMap.refundSubtotal.toFixed(2)}</td>
                           </tr>
                           {this.props.rmaData.orderMap.refundShipping !== 0 &&
                           <tr>
                               <td align="right">Return Shipping</td>
                               <td className="float-right">
                                   <i>{'$' + this.props.rmaData.orderMap.refundShipping.toFixed(2)}</i>
                               </td>
                           </tr>
                           }
                           <tr>
                              <td align="right"><strong>Total Estimated Refund</strong></td>
                              <td className="float-right"><strong>${this.props.rmaData.orderMap.totalEstimatedRefund.toFixed(2)}</strong></td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  }
                  
               </div>
            </div>
          </div>         
     </div>
        );
    }
}
 

const mapStateToProps = (state) =>({
    rmaData: state.orderDataDetails.returnRMAItemDetails
  });  

export default connect(mapStateToProps, { fetchRMAItemDetails })(RMAPopUp);

 





// WEBPACK FOOTER //
// ./src/components/OrderDetails/RMAPopUp.js